import { Box, Stack } from "@mui/material";
import { ROUTES } from "src/consts/routes";
import { MSG_IDS } from "src/consts/msgIds";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import PageTitle from "src/components/Displays/PageTitle";
import PageSubTitle from "src/components/Displays/PageSubTitle";
import PrimaryButton from "src/components/Shared/PrimaryButton";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useSessionStorage } from "src/hooks/useSessionStorage";
import { FUNNEL_ORDER_RESPONSE, SESSION_KEYS } from "src/consts/session";

const ErrorPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const msgId = searchParams.get("msgId") ?? "";

  const [title, setTitle] = useState("");
  const [subTitle, setSubTitle] = useState("");
  const [backBtnText, setBackBtnText] = useState("");
  const [backBtnPostcodeText, setBackBtnPostcodeText] = useState("");

  const [getFunnelOrderResponse] = useSessionStorage<FUNNEL_ORDER_RESPONSE>(
    SESSION_KEYS.FUNNEL_ORDER_RESPONSE
  );

  useEffect(() => {
    switch (msgId) {
      case MSG_IDS.no_prices_available:
        setTitle(t("page.errorPage.title_default"));
        setSubTitle(t(`page.errorPage.${MSG_IDS.no_prices_available}`));
        setBackBtnPostcodeText(t(`page.errorPage.goToPostcode`));
        break;
      case MSG_IDS.funnel_order_400:
        setTitle(t("page.errorPage.title_funnel_order_400"));
        setSubTitle(t(`page.errorPage.sub_title_funnel_order_400`));
        setBackBtnPostcodeText(t("page.errorPage.goToPV"));
        break;
      case MSG_IDS.smart_charging_transfer_error:
        setTitle("Oops...");
        setSubTitle(
          "Es gab ein Problem mit der Verbindung. Bitte versuche es zu einem späteren Zeitpunkt erneut. Sollte das Problem weiterhin bestehen, überprüfe deine Internetverbindung oder kontaktiere unseren Support.\n\nSollte das Problem weiterhin bestehen, überprüfen Sie Ihre Internetverbindung oder kontaktieren Sie unseren Support."
        );
        setBackBtnText(t("page.errorPage.button_default"));
        break;
      case MSG_IDS.smart_charging_terms_accept_error:
        setTitle("Oops...");
        setSubTitle(
          "Es gab ein Problem mit der Verbindung. Bitte versuchen Sie es zu einem späteren Zeitpunkt erneut.\n\nSollte das Problem weiterhin bestehen, überprüfen Sie Ihre Internetverbindung oder kontaktieren Sie unseren Support."
        );
        setBackBtnText(t("page.errorPage.button_default"));
        break;

      case MSG_IDS.smart_charging_onboarding_transfer_error:
        setTitle("Oops...");
        setSubTitle(
          "Es gab ein Problem mit der Verbindung. Bitte versuchen Sie es zu einem späteren Zeitpunkt erneut.\n\nSollte das Problem weiterhin bestehen, überprüfen Sie Ihre Internetverbindung oder kontaktieren Sie unseren Support."
        );
        break;
      default:
        setTitle(t("page.errorPage.title_default"));
        setSubTitle(t(`page.errorPage.sub_title_default`));
        setBackBtnText(t("page.errorPage.button_default"));
        break;
    }
  }, [t, msgId]);

  const handleBackClick = () => {
    if (
      msgId === MSG_IDS.smart_charging_transfer_error ||
      msgId === MSG_IDS.smart_charging_terms_accept_error
    ) {
      navigate(-1);
      return;
    }

    let redirectUrl = getFunnelOrderResponse()?.redirectUrl;

    if (redirectUrl && redirectUrl !== "") {
      window.location.href = redirectUrl;
      return;
    }
    navigate(-1);
  };

  const handleBackPostcodeClick = () => {
    navigate(ROUTES.PV_SETUP);
  };

  return (
    <>
      <Stack gap={2} sx={{ mt: { xs: 8, sm: 0 } }}>
        {title && <PageTitle text={title} />}
        <>
          <Box height={8} />
          <PageSubTitle text={subTitle} />
        </>
        <Box height={24} />

        {backBtnText && (
          <Box>
            <PrimaryButton
              text={backBtnText}
              sx={{
                border: "1px solid white",
              }}
              onClick={handleBackClick}
            />
          </Box>
        )}

        {backBtnPostcodeText && (
          <Box>
            <PrimaryButton
              text={backBtnPostcodeText}
              sx={{
                textTransform: "none",
                border: "1px solid white",
              }}
              onClick={handleBackPostcodeClick}
            />
          </Box>
        )}
      </Stack>
    </>
  );
};

export default ErrorPage;
